import { render, staticRenderFns } from "./LineaTicket.vue?vue&type=template&id=d2df311a&"
import script from "./LineaTicket.vue?vue&type=script&lang=js&"
export * from "./LineaTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports